import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-73e080a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tree-head"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  class: "",
  style: {"overflow-y":"auto","height":"calc(100% - 50px)","padding":"5px","box-sizing":"border-box"}
}
const _hoisted_5 = { class: "el-menu-item menu-item" }
const _hoisted_6 = {
  key: 0,
  class: "first-level"
}
const _hoisted_7 = ["title"]
const _hoisted_8 = {
  key: 1,
  class: "cm-align-center",
  style: {"justify-content":"space-between","padding-right":"8px"}
}
const _hoisted_9 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_ImportGroupDialog = _resolveComponent("ImportGroupDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "tree-container",
      style: _normalizeStyle({ width: _ctx.isFold ? '0' : _ctx.width, ..._ctx.treeStyle })
    }, [
      (_ctx.isFold)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "fold-icon",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFold && _ctx.toggleFold(...args))),
            style: {"position":"absolute","left":"0","top":"5px","width":"20px","height":"20px"}
          }, [
            _createVNode(_component_CmSvgIcon, {
              name: "assets/icons/right-fold",
              size: 18,
              monochrome: ""
            })
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass({ 'el-card': _ctx.isBorder && !_ctx.isFold }),
            style: {"height":"100%","box-sizing":"border-box"}
          }, [
            (_ctx.showHeader)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('groupManage.groupArea')), 1),
                  (_ctx.foldable)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleFold && _ctx.toggleFold(...args))),
                        title: _ctx.isFold ? _ctx.$t('groupManage.openAllTerminals') : '',
                        class: "fold-btn"
                      }, [
                        _createVNode(_component_CmSvgIcon, {
                          name: "views/dashboard/_components/group-tree/_images/left-arrow",
                          monochrome: "",
                          size: 16
                        })
                      ], 8, _hoisted_3))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_tree, {
                data: _ctx.groups,
                ref: "baseTree",
                indent: 7,
                "node-key": "group_id",
                "default-expand-all": "",
                "expand-on-click-node": false,
                "icon-class": "el-icon-caret-right",
                props: { disabled: _ctx.isNodeDisabled },
                onNodeClick: _ctx.clickNode,
                class: "cm-group-tree"
              }, {
                default: _withCtx((row) => [
                  _createElementVNode("div", _hoisted_5, [
                    (row.data.group_id === -1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["name-size", `name-size-${row.data.level} ${_ctx.showDot && row.data.inherit ? 'show-dot' : ''} ${(row.data.children && row.data.children.length > 0) ? 'folder-type' : 'file-type'}`]),
                            title: row.data.name
                          }, _toDisplayString(`${row.data.name}(${row.data[_ctx.countKey] || 0})`), 11, _hoisted_7)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["name-size", `name-size-${row.data.level} ${_ctx.showDot && row.data.inherit ? 'show-dot' : ''} ${(row.data.children && row.data.children.length > 0) ? 'folder-type' : 'file-type'}`]),
                            title: row.data.name
                          }, _toDisplayString(`${row.data.name}(${row.data[_ctx.countKey] || 0})`), 11, _hoisted_9)
                        ]))
                  ])
                ]),
                _: 1
              }, 8, ["data", "props", "onNodeClick"])
            ])
          ], 2))
    ], 4),
    _createVNode(_component_ImportGroupDialog, {
      modelValue: _ctx.importDialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.importDialogVisible) = $event)),
      onSuccess: _ctx.handleImportSuccess
    }, null, 8, ["modelValue", "onSuccess"])
  ], 64))
}